import React, { useState, useEffect } from "react";
import { Skeleton } from "@mui/material";
import { AdvancedMarker, APIProvider, Map } from "@vis.gl/react-google-maps";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const MapComponent = (address) => {
  const [center, setCenter] = useState(null);
  const location = address?.streetAddress + ", " + address?.city;
  const fetchCoordinates = async (location) => {
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
        location
      )}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`
    );
    
    const data = await response.json();

    if (data.results.length > 0) {
      const location = data.results[0].geometry.location;
      setCenter(location);
    } else {
    }
  };

  useEffect(() => {
    if (address?.streetAddress != null && address?.city != null) {
      fetchCoordinates(location);
    }
  }, [address]);

  if (!center) {
    return <Skeleton width={"100%"} height={"400px"} />;
  }

  return (
    <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
      <Map
      style={{  
        width: "100%",
        height: "400px"
      }}
      defaultCenter={center}
      defaultZoom={15}
      disableDefaultUI={true}
      mapId={"DEMO_MAP_ID"}>
        <AdvancedMarker position={center} />
      </Map>
    </APIProvider>
  );
};

export default MapComponent;
